/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteDirectoryInput = {|
  id?: ?string,
  clientMutationId?: ?string,
|};
export type ExperimentDashDeleteDirectoryMutationVariables = {|
  input: DeleteDirectoryInput
|};
export type ExperimentDashDeleteDirectoryMutationResponse = {|
  +deleteDirectory: ?{|
    +ok: ?boolean,
    +id: ?string,
  |}
|};
export type ExperimentDashDeleteDirectoryMutation = {|
  variables: ExperimentDashDeleteDirectoryMutationVariables,
  response: ExperimentDashDeleteDirectoryMutationResponse,
|};
*/


/*
mutation ExperimentDashDeleteDirectoryMutation(
  $input: DeleteDirectoryInput!
) {
  deleteDirectory(input: $input) {
    ok
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteDirectoryPayload",
    "kind": "LinkedField",
    "name": "deleteDirectory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExperimentDashDeleteDirectoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExperimentDashDeleteDirectoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d3201003448d12f074c1e34574fe51fb",
    "id": null,
    "metadata": {},
    "name": "ExperimentDashDeleteDirectoryMutation",
    "operationKind": "mutation",
    "text": "mutation ExperimentDashDeleteDirectoryMutation(\n  $input: DeleteDirectoryInput!\n) {\n  deleteDirectory(input: $input) {\n    ok\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c087976893afc12ac453b2243dc5e3d5';

module.exports = node;
